const AzureVoiceService = require( './AzureVoiceService' );
const ElevenLabsVoiceService = require( './ElevenLabsVoiceService' );

const voiceServices = {
	'azure': {
		name: 'Azure',
		handler: AzureVoiceService
	},
	'elevenlabs': {
		name: 'ElevenLabs',
		handler: ElevenLabsVoiceService
	}
};

/**
 * 
 * @param {String} service 
 * @returns VoiceService
 */
function VoiceService( service ) {
	if ( service in voiceServices ) {
		return new voiceServices[service].handler();
	}

	throw 'Unknown voice service: ' + service;
}

module.exports = {
	VoiceService,
	voiceServices
};